import { useNotifications } from './NotificationsProvider';

// The notifications control is an explicit SWITCH, not a label that reads as
// status (T-0200): "🔔 Notifications on" left it ambiguous whether it reported a
// state or performed an action. `role="switch"` + `aria-checked` names the state
// to assistive tech, and the track/thumb + "On"/"Off" name it to everyone else.
// Checked = notifications ON = not muted.

interface MuteToggleProps {
  roomId: string;
}

export function MuteToggle({ roomId }: MuteToggleProps) {
  const { isMuted, isMuteUpdating, getMuteError, toggleMute } =
    useNotifications();
  const muted = isMuted(roomId);
  const updating = isMuteUpdating(roomId);
  const error = getMuteError(roomId);
  const on = !muted;

  return (
    <>
      <button
        type="button"
        role="switch"
        className="mute-toggle"
        data-on={on}
        onClick={() => {
          void toggleMute(roomId);
        }}
        aria-checked={on}
        aria-busy={updating || undefined}
        aria-label="Notifications for this space"
        disabled={updating}
      >
        <span className="mute-toggle-icon" aria-hidden="true">
          {on ? '🔔' : '🔕'}
        </span>
        <span className="mute-toggle-track" aria-hidden="true">
          <span className="mute-toggle-thumb" />
        </span>
        <span className="mute-toggle-state">{on ? 'On' : 'Off'}</span>
      </button>
      {updating && (
        <span className="mute-toggle-status" role="status">
          Updating notifications...
        </span>
      )}
      {error && (
        <span className="mute-toggle-error" role="alert">
          {error}
        </span>
      )}
    </>
  );
}
